import styled from "styled-components";

export default c => styled(c)`
  .create-sub-optionals {
    cursor: pointer;
    text-align: center;
    margin: 16px 0px 0px 8px;
  }

  .optionals-errors {
    color: red;
  }

  .align-delete-button {
    padding-top: 40px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/app/registration/optional-groups/form/style.js